import React from 'react';
import { MapPinIcon, StarIcon } from 'lucide-react';
import { Section } from './Section';
import { deepQuotes } from '../data/content';
export function Testimonials() {
  return <Section tone="tint" eyebrow="Testimonios" title="Lo que dicen las mujeres que ya rescataron su cuerpo" data-id="element-236" data-mp="3fznrfeogiyy7">
      <ul className="mx-auto max-w-narrow divide-y divide-blue-200/70" data-id="element-237" data-mp="3azjcvu740eam">
        {deepQuotes.map(quote => <li key={`${quote.author}-${quote.city}`} className="grid gap-4 py-7 first:pt-0 last:pb-0 md:grid-cols-[minmax(0,14rem)_1fr] md:gap-10" data-id="element-238" data-mp="36zqyv1yy5fxv">
            <div className="flex items-start gap-3" data-id="element-239" data-mp="2x007va9lhj2j">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-blue-900 font-display text-xs font-bold text-gold-300" data-id="element-240" data-mp="2x2mm1sqzqwtq">
                {quote.initials}
              </span>
              <span data-id="element-241" data-mp="qac22zzb8b0e">
                <span className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-242" data-mp="q9u15q1pd8m5">
                  {Array.from({
                length: 5
              }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-gold-500 text-gold-500" aria-hidden="true" data-id="element-243" data-mp="h4n5afz667d1" data-mpi={index} />)}
                </span>
                <span className="mt-1.5 block font-display font-extrabold tracking-tight text-ink" data-id="element-244" data-mp="c6ljvoe9tvye">
                  {quote.author}
                </span>
                <span className="inline-flex items-center gap-1 text-sm text-blue-900/60" data-id="element-245" data-mp="zx7thk3xboai">
                  <MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-246" data-mp="14uzm6gce7efr" />
                  {quote.city}
                </span>
              </span>
            </div>
            <blockquote className="text-lg italic leading-relaxed text-ink md:text-xl" data-id="element-247" data-mp="v4xvrhwkhjxo">
              “{quote.quote}”
            </blockquote>
          </li>)}
      </ul>
    </Section>;
}